<div
  class="fini-splash"
  [class.closing]="isClosing()"
  [class.hidden]="isHidden()"
>
  <img
    class="splash-logo"
    [class.closing]="isClosing()"
    [class.hidden]="isHidden()"
    src="/assets/img/logo/ico-sq-hq.png"
    alt="logo"
  />
</div>

<div class="slowly hide" [class.hide]="!isLoadingSlowly()">
  <mat-progress-bar mode="indeterminate"> </mat-progress-bar>
</div>
